import React from 'react';
import styled from 'styled-components';
import {images} from 'config';
import {isSegregated, getSegregated} from "../../../config/subdomains";

const Footer = () => (
    <Content>
        <div className="footer-line">leaf</div>
        <div className="circle-design">
            <div className="footer-bottom">

                {isSegregated() ? (
                    <p className="segregated">
            <span className="footer-logo">
              <img src={images.municipality_logo[getSegregated()]} width="100" height="100" alt="Susasan"/>
            </span>
                        <br/>
                        <div className="w300">काे सहकार्यमा बनाइएकाे ।</div>
                    </p>
                ) : (
                    <p className="non-segregated">
          <span className="footer-logo">
            <img src={images.susasanLogoBlue} width="122" height="34" alt="Susasan"/>
          </span>
                        काे सहकार्यमा बनाइएकाे ।
                    </p>
                )}
            </div>
        </div>
    </Content>
);

export default Footer;

const Content = styled.div`
    .footer-line {
        background: url(${images.icons.leaf}) no-repeat center;
        height: 25px;
        margin: 0 auto 15px;
        position: relative;
        text-indent: -9999px;
        width: 387px;

        &:before,
        &:after {
            background: rgba(49, 149, 231, 0.2);
            content: '';
            height: 1px;
            position: absolute;
            top: 12px;
            width: 162px;
        }

        &:before {
            left: 0;
        }

        &:after {
            right: 0;
        }

        @media screen and (max-width: 768px) {
            width: 100%;
        }
    }

    .w300 {
        width: 300px;
        margin-bottom: 10px;
    }

    .circle-design {
        height: 140px;
        overflow: hidden;
    }

    .footer-bottom {
        border: 1px solid rgba(1, 73, 131, 0.1);
        border-radius: 50%;
        height: 413px;
        margin: 0 auto;
        width: 413px;

        @media screen and (max-width: 768px) {
            width: 100%;
        }

        p {
            color: rgba(44, 45, 45, 0.7);
            font-size: 14px;
            height: 64px;
            margin: 0 auto;
            width: 123px;

            &.segregated {
                padding: 20px 10px 0;
            }

            &.non-segregated {
                padding: 40px 0 35px;
            }
        }
    }

    .footer-logo {
        height: 120px;
    }
`;



// WEBPACK FOOTER //
// ./src/components/layouts/footer/footer.js